import { render, staticRenderFns } from "./solutionSJZT.vue?vue&type=template&id=0bee73f2&scoped=true"
import script from "./solutionSJZT.vue?vue&type=script&lang=js"
export * from "./solutionSJZT.vue?vue&type=script&lang=js"
import style0 from "./solutionSJZT.vue?vue&type=style&index=0&id=0bee73f2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bee73f2",
  null
  
)

export default component.exports